export { A as AudioType, a as CollectPolicyType, c as CollectPublication, b as CollectType, C as ContentFocus, I as ImageType, N as NftAttributeDisplayType, R as ReferencePolicyType, S as SupportedFileType, V as VideoType, i as isPaidCollectRequest } from '../../../dist/types-7725b578.esm.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../dist/asyncToGenerator-c002e3ca.esm.js';
import { h as _getPrototypeOf, _ as _inherits, a as _createSuper, b as _classCallCheck, c as _createClass } from '../../../dist/createClass-3115abc1.esm.js';
import { invariant, success } from '@lens-protocol/shared-kernel';
import { D as DelegableProtocolCallUseCase } from '../../../dist/DelegableProtocolCallUseCase-68560579.esm.js';

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}

var CreateComment = /*#__PURE__*/function (_DelegableProtocolCal) {
  _inherits(CreateComment, _DelegableProtocolCal);
  var _super = _createSuper(CreateComment);
  function CreateComment() {
    _classCallCheck(this, CreateComment);
    return _super.apply(this, arguments);
  }
  _createClass(CreateComment, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              invariant(request.media || request.content, 'One of post media or content is required');
              _context.next = 3;
              return _get(_getPrototypeOf(CreateComment.prototype), "execute", this).call(this, request);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
  return CreateComment;
}(DelegableProtocolCallUseCase);

var CreateMirror = /*#__PURE__*/function (_DelegableProtocolCal) {
  _inherits(CreateMirror, _DelegableProtocolCal);
  var _super = _createSuper(CreateMirror);
  function CreateMirror() {
    _classCallCheck(this, CreateMirror);
    return _super.apply(this, arguments);
  }
  return _createClass(CreateMirror);
}(DelegableProtocolCallUseCase);

var CreatePost = /*#__PURE__*/function (_DelegableProtocolCal) {
  _inherits(CreatePost, _DelegableProtocolCal);
  var _super = _createSuper(CreatePost);
  function CreatePost() {
    _classCallCheck(this, CreatePost);
    return _super.apply(this, arguments);
  }
  _createClass(CreatePost, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              invariant(request.media || request.content, 'One of post media or content is required');
              _context.next = 3;
              return _get(_getPrototypeOf(CreatePost.prototype), "execute", this).call(this, request);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
  return CreatePost;
}(DelegableProtocolCallUseCase);

var HidePublication = /*#__PURE__*/function () {
  function HidePublication(hidePublicationGateway, hidePublicationPresenter) {
    _classCallCheck(this, HidePublication);
    this.hidePublicationGateway = hidePublicationGateway;
    this.hidePublicationPresenter = hidePublicationPresenter;
  }
  _createClass(HidePublication, [{
    key: "hide",
    value: function () {
      var _hide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.hidePublicationGateway.hide(request);
            case 2:
              this.hidePublicationPresenter.present(request.publicationId);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function hide(_x) {
        return _hide.apply(this, arguments);
      }
      return hide;
    }()
  }]);
  return HidePublication;
}();

var Reaction = /*#__PURE__*/function () {
  function Reaction(gateway, presenter) {
    _classCallCheck(this, Reaction);
    this.gateway = gateway;
    this.presenter = presenter;
  }
  _createClass(Reaction, [{
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.presenter.add(request);
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return this.gateway.add(request);
            case 5:
              _context.next = 12;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              _context.next = 11;
              return this.presenter.remove(request);
            case 11:
              throw _context.t0;
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 7]]);
      }));
      function add(_x) {
        return _add.apply(this, arguments);
      }
      return add;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.presenter.remove(request);
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return this.gateway.remove(request);
            case 5:
              _context2.next = 12;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](2);
              _context2.next = 11;
              return this.presenter.add(request);
            case 11:
              throw _context2.t0;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 7]]);
      }));
      function remove(_x2) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }]);
  return Reaction;
}();

var ReportPublication = /*#__PURE__*/function () {
  function ReportPublication(gateway, presenter) {
    _classCallCheck(this, ReportPublication);
    this.gateway = gateway;
    this.presenter = presenter;
  }
  _createClass(ReportPublication, [{
    key: "report",
    value: function () {
      var _report = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.gateway.report(request);
            case 2:
              this.presenter.present(success());
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function report(_x) {
        return _report.apply(this, arguments);
      }
      return report;
    }()
  }]);
  return ReportPublication;
}();

export { CreateComment, CreateMirror, CreatePost, HidePublication, Reaction, ReportPublication };
